var $6118e31cd0ab5ebd$exports = {};
$6118e31cd0ab5ebd$exports = {
    "loading": `Laadimine...`,
    "placeholder": `Valige\u{2026}`
};


export {$6118e31cd0ab5ebd$exports as default};
//# sourceMappingURL=et-EE.mjs.map
